import { render, staticRenderFns } from "./UploadDocumentHistoryModal.vue?vue&type=template&id=dcef41d6&"
import script from "./UploadDocumentHistoryModal.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports